<script>
	import { statusMapStr } from "src/utils/options";
	import SidePopup from "../../../components/SidePopup/SidePopup.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { imageLightbox, imageLightboxCaptions } from "src/store/store";
	import Lightbox from "../../../components/Lightbox/Lightbox.svelte";
	import { convert } from "src/services/helpers";

	export let task;
	export let toggleDetails;

	let modalOpen = false;
	let imgIndex = 0;
	let photos = [];
	let videos = [];
	let taskAuditTrail = [];
	let hasMedia = false;
	let hasOperatorRemarks = false;
	let operatorSectionTitle = "Operator’s Remarks and Photos/videos";
	let videoModalOpen = false;
	let videoIndex = 0;

	$: photos = task.media.filter(
		(mediaItem) => mediaItem?.type === "Photo" && mediaItem?.url
	);
	$: videos = task.media.filter(
		(mediaItem) => mediaItem?.type === "Video" && mediaItem?.url
	);
	$: taskAuditTrail = task.auditTrail;
	$: hasMedia = task.media.length > 0;
	$: hasOperatorRemarks =
		task.operatorRemarks !== "" && task.operatorRemarks != null;
	$: operatorSectionTitle =
		!hasMedia && hasOperatorRemarks
			? "Operator's Remarks"
			: "Operator’s Remarks and Photos/videos";

	function handleOpenImage(i) {
		imageLightbox.set(photos.map((photo) => photo.url));
		imageLightboxCaptions.set(photos.map((photo) => photo.caption));
		imgIndex = Number(i);
		modalOpen = !modalOpen;
	}

	function handleOpenVideo(i) {
		imageLightbox.set(videos.map((v) => v.url));
		imageLightboxCaptions.set(videos.map((v) => v.caption ?? ""));
		videoIndex = Number(i);
		videoModalOpen = true;
	}
</script>

{#if modalOpen}
	<Lightbox
		on:click={() => (modalOpen = false)}
		imageShowingIndex={imgIndex}
	/>
{/if}
{#if videoModalOpen}
	<Lightbox
		on:click={() => (videoModalOpen = false)}
		imageShowingIndex={videoIndex}
	/>
{/if}
<SidePopup {toggleDetails}>
	<div class="popup-item">
		<h5>
			{task.presetTask.code} - {task.presetTask.description}
		</h5>
	</div>
	<div class="popup-mid popup-item">
		<Row class="popup-item">
			<Col xs={6}>
				<div class="category-name">Task Status</div>
				<div>{@html statusMapStr[task.status]}</div>
			</Col>
			<Col xs={6}>
				<div class="category-name">Priority</div>
				<div>{task.priority}</div>
			</Col>
		</Row>
		<div class="popup-item">
			<div class="category-name">Planner's Remarks</div>
			<div>{task.plannerRemarks}</div>
		</div>
		<div class="popup-item">
			<div class="category-name">
				{operatorSectionTitle}
			</div>
			{#if hasMedia}
				<div class="d-flex flex-wrap gap-1.5">
					{#each photos as img, i}
						<img
							class="remark-img"
							src={img.url}
							alt="task-remark"
							on:click={() => handleOpenImage(i)}
							on:keydown={() => {}}
						/>
					{/each}
					{#each videos as _, i}
						<button
							class="remark-video"
							on:click={() => handleOpenVideo(i)}
						>
							Watch Video
						</button>
					{/each}
				</div>
			{/if}
			{#if hasOperatorRemarks}
				<div class="operator-remarks">{task.operatorRemarks}</div>
			{:else if !hasMedia && !hasOperatorRemarks}
				<div>-</div>
			{/if}
		</div>
	</div>
	<div class="popup-item">
		<Col xs={12}>
			<Row class="popup-header">
				<Col>
					<b>Date</b>
				</Col>
				<Col>
					<b>Description</b>
				</Col>
			</Row>

			{#each taskAuditTrail as task}
				<Row class="popup-item">
					<Col>{convert(task.timestamp)}</Col>
					<Col>{task.description}</Col>
				</Row>
			{/each}
		</Col>
	</div></SidePopup
>

<style>
	.remark-img {
		width: 86px;
		height: 86px;
		margin-right: 2px;
	}

	.remark-video {
		width: 86px;
		height: 86px;
		margin-right: 2px;
		border-radius: 4px;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding: 4px;
		border: none;
		cursor: pointer;
	}

	h5 {
		font-weight: 800;
	}

	.operator-remarks {
		margin-top: 16px;
	}

	.category-name {
		margin-bottom: 8px;
	}
</style>
